export function parseLocalStorage<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    console.warn(`[localStorage] Corrupted value for key "${key}", resetting to default.`);
    return fallback;
  }
}
